<div class="w-100 h-100 br-1h ov-h gradient-border">
	<div class="w-100 h-100 fl fl-dir-c fl-ai-fs fl-jc-fs bg-280 br-1h">
		<div class="w-100 fl-fixed fl fl-ai-c fl-jc-fs fl-gap-0h p-1">
			<div buttonIcon size="S" class="invisible" [disabled]="true">
				<i class="icon-cross-close"></i>
			</div>

			<div class="fl-adaptable fl fl-ai-c fl-jc-c fl-gap-2 ov-h">
				<p class="ellipsis fc-500">Translate to:</p>

				<button 
					#anchor 
					buttonBasic 
					(click)="menu?.open()" 
					class="bg-190" 
					style="padding: 6px 8px 6px 16px;"
				>
					<span class="fl fl-dir-c fl-ai-fs fl-jc-fs">
						@for (item of $languages(); track item.key) {
							<span class="max-w-100 h-0 invisible ellipsis">
								{{ item.value }}
							</span>
						}
						<span class="max-w-100 ellipsis fc-500">{{
							$selectedLanguage().value
						}}</span>
					</span>
					<i class="icon-chevron chevron-down fs-icon-s"></i>
				</button>
			</div>

			<button buttonIcon size="S" (click)="close()">
				<i class="icon-cross-close"></i>
			</button>
		</div>
		<div class="pos-rel w-100 fl-adaptable fl fl-dir-c top-gradient ov-auto">
			<div class="w-100 fl-adaptable fl fl-ai-fs fl-jc-fs p-2-tb p-3-rl ov-auto">
				<p class="w-100 ws-pl wb-bw" [class.text-right-to-left]="$showRightToLeft()">
					@if ($translatedValue().loading) {
						<span
							class="fl-inline fl-ai-c fl-jc-fs p-1-r"
							style="height: calc(1em * var(--font-line-height))"
						>
							<loader-three-dots></loader-three-dots>
						</span>
						Translating...
					} @else if ($translatedValue().failed) {
						There was an error translating.
					} @else {
						{{ $translatedValue().value }}
					}
				</p>
			</div>
		</div>
	</div>
</div>

<client-reach-menu #menu [activeSection]="'1'" (closed)="onMenuClosed()">
	<ng-container *clientReachMenuSection="'1'; anchor: anchor; let isMobile = isMobile">
		<div
			ngProjectAs="[~title]"
			class="w-100 reach-input-widget-wrapper p-1h-rl p-1-tb br-1 fl fl-ai-c fl-jc-fs fl-gap-1h bg-270 bordered"
		>
			<i class="icon-search fc-400 fs-icon-s"></i>
			<input
				type="search"
				class="w-100 input-widget"
				placeholder="Search language"
				[(ngModel)]="$query"
			/>
		</div>

		<div ngProjectAs="[~right]">
			<button buttonIcon (click)="menu?.close()">
				<i class="icon-cross"></i>
			</button>
		</div>

		<div class="pos-rel w-100 h-100 fl fl-dir-c fl-ai-fs fl-jc-fs fl-gap-0q ov-auto">
			@if (!isMobile) {
				<div class="w-100 pos-sticky pos-t-0 p-1 z-index-1 bg-180">
					<div
						class="w-100 reach-input-widget-wrapper p-1h-rl p-1-tb br-1 fl fl-ai-c fl-jc-fs fl-gap-1h bg-270 bordered"
					>
						<i class="icon-search fc-400 fs-icon-s"></i>
						<input
							type="search"
							class="w-100 input-widget"
							placeholder="Search language"
							[(ngModel)]="$query"
							autofocusOnInit
						/>
					</div>
				</div>
			}

			@for (item of $languages(); track item.key) {
				<div class="w-100 p-1-rl">
					<button
						buttonBasic
						class="w-100 fl-gap-0q hover-parent"
						(click)="selectLanguage(item.key); menu?.close()"
					>
						<span
							class="fl-adaptable ellipsis fc-800-on-hover-parent"
							[class.fc-800]="item.selected"
							[class.fc-500]="!item.selected"
							>{{ item.value }}</span
						>
						<i
							class="fl-fixed fc-primary fs-l"
							[class.invisible]="!item.selected"
							[class.icon-tick-black]="item.selected"
						></i>
					</button>
				</div>
			}
		</div>
	</ng-container>
</client-reach-menu>
